import { createActionGroup, props } from '@ngrx/store';
import { Voce, CreateVoceDto, UpdateVoceDto } from '../../core/models/voci.model';

export const VociActions = createActionGroup({
  source: 'Voci',
  events: {
    'Load By Capitolo Id': props<{ idCapitolo: number }>(),
    'Load By Capitolo Id Success': props<{ items: Voce[] }>(),
    'Load By Capitolo Id Failure': props<{ error: string }>(),

    'Load Details': props<{ id: number }>(),
    'Load Details Success': props<{ item: Voce }>(),
    'Load Details Failure': props<{ error: string }>(),

    'Create': props<{ dto: CreateVoceDto; idPreventivo: number }>(),
    'Create Success': props<{ id: number; idPreventivo: number }>(),
    'Create Failure': props<{ error: string }>(),

    'Update': props<{ id: number; changes: UpdateVoceDto; idPreventivo: number }>(),
    'Update Success': props<{ id: number; idPreventivo: number }>(),
    'Update Failure': props<{ error: string }>(),

    'Delete': props<{ id: number; idPreventivo: number }>(),
    'Delete Success': props<{ id: number; idPreventivo: number }>(),
    'Delete Failure': props<{ error: string }>(),

    'Delete Suggestion': props<{ id: number }>(),
    'Delete Suggestion Success': props<{ id: number }>(),
    'Delete Suggestion Failure': props<{ error: string }>(),
  },
});
